// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/img/backgroud-bosch.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-unauthorize {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 91dvh;
  background-size: cover;
  background-position: center;
  align-items: center;
  justify-content: center;
  display: flex;
}

.unautho-container {
  background-color: white;
  display: flex;
  max-width: 600px;
  min-width: 600px;
  flex-direction: column;
  min-height: 350px;
}

.container-una {
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link-one {
  color: #007bc0;
  text-decoration: none;
  font-weight: 700;
  margin-left: 5px;
}

.img-alert {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}

.text-exp {
  color: #007bc0;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 20px;
}

.text-apli {
  margin-top: 25px;
}

.line {
  color: white;
  margin-top: 1px #c1c7cc;
  width: 400px;
}

.container-grup {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.text-grup {
  background-color: #e0e2e5;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: 700;
}

.container-role {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 100%;
  border-bottom: 1px solid #c1c7cc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Unauthorize/Unauthorize.css"],"names":[],"mappings":"AAAA;EACE,yDAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gCAAgC;AAClC","sourcesContent":[".container-unauthorize {\n  background-image: url(\"/src/assets/img/backgroud-bosch.png\");\n  height: 91dvh;\n  background-size: cover;\n  background-position: center;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\n.unautho-container {\n  background-color: white;\n  display: flex;\n  max-width: 600px;\n  min-width: 600px;\n  flex-direction: column;\n  min-height: 350px;\n}\n\n.container-una {\n  padding: 20px 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.link-one {\n  color: #007bc0;\n  text-decoration: none;\n  font-weight: 700;\n  margin-left: 5px;\n}\n\n.img-alert {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 5px;\n}\n\n.text-exp {\n  color: #007bc0;\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n.text-apli {\n  margin-top: 25px;\n}\n\n.line {\n  color: white;\n  margin-top: 1px #c1c7cc;\n  width: 400px;\n}\n\n.container-grup {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.text-grup {\n  background-color: #e0e2e5;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  font-weight: 700;\n}\n\n.container-role {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100%;\n  border-bottom: 1px solid #c1c7cc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
